import { Component, OnInit, Input } from '@angular/core';
 
@Component({
  selector: 'demo-alert-dynamic-html',
  templateUrl: './alerts.component.html'
})
export class DemoAlertDynamicHtmlComponent implements OnInit {

  @Input() alertInfo: any;
  alerts: any = [];
  dismissible = true;
 
  constructor() {
  }
  async ngOnInit() {
    this.alerts = this.alertInfo;
  }
}